module.exports = __webpack_public_path__ + "img/img2.6d485d6f.png";